import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { analyticsPath } from './analytics-url';
import { DataLayerService } from './data-layer.service';

@Injectable({ providedIn: 'root' })
export class PageViewTrackerService {
  private initialized = false;

  private readonly router = inject(Router);
  private readonly dataLayerService = inject(DataLayerService);
  private readonly document = inject(DOCUMENT);

  init(): void {
    if (this.initialized) return;
    this.initialized = true;

    this.trackPageView(
      this.router.url || this.document?.location?.pathname || '/'
    );

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navigation = event as NavigationEnd;
        this.trackPageView(navigation.urlAfterRedirects);
      });
  }

  private trackPageView(path: string): void {
    path = analyticsPath(path);
    const location = this.buildPageLocation(path);

    this.dataLayerService.pushEvent('page_view', {
      page_path: path,
      page_location: location,
      page_title: this.document?.title || undefined,
    });
  }

  private buildPageLocation(path: string): string | undefined {
    const win = typeof window !== 'undefined' ? window : null;
    if (!win?.location?.origin) return undefined;
    return `${win.location.origin}${path}`;
  }
}
